import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../../Optics/Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';
import { loadingDividerDataComponent, loadingPolishingDataComponent, loadingPonBoxDataComponent } from '../../../../Optics/LoadingData/LoadingDataComponents';
import Select from 'react-select';
import { DeletePonBoxConstruction, UpdateDivider2ModelPonBoxConstruction, UpdateDividerModelPonBoxConstruction, UpdateNumberPonBoxConstructor, UpdatePigtailAdapterPonBoxConstruction, UpdatePonBoxDescriptionConstruction, UpdatePonBoxNameConstruction } from '../../../WriteData/UpdateConstructCommunications';

const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '14px',
    border: '1px solid #ffffff',
    marginBottom: '5px',
    marginTop: '10px',
    width: '280px'
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
    
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
    fontSize: '14px',
    width: '280px'
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};

const PonBoxDescriptEditingModal = ({ open, onClose, onClose2, content, cantonRefresh, setIsComponentСhangeCoorPonBox}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [textComment, setTextComment] = useState(content.description);
  const [statusChange, setStatusChange] = useState(false);
  const [ponBoxData, setPonBoxData] = useState([]);
  const [ponBoxId, setPonBoxId] = useState("");
 
  const [dividerData, setDividerData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [dividerId, setDividerId] = useState("");

  const [showSecondDivider, setShowSecondDivider] = useState(content.divider2Id !== 5);
  const [inputValue2, setInputValue2] = useState("");
  const [divider2Id, setDivider2Id] = useState("");

  const [textNumberBox, setTextNumberBox] = useState(content.numberBox);
  const [statusChangeNumberBox, setStatusChangeNumberBox] = useState(false);
  const [polishingData, setPolishingData] = useState([]);
  const [polishingId, setPolishingId] = useState(content.polishingId);
  const [pigtailCount, setPigtailCount] = useState(content.pigtailCount);
  const [adapterCount, setAdapterCount] = useState(content.adapterCount);
  const [statusChangeAdapter, setStatusChangeAdapter] = useState(false);
  const [statusChangePigtail, setStatusChangePigtail] = useState(false);

  const handleСhangeCoor= (event) => {
    handleCloseDialogs();
    setIsComponentСhangeCoorPonBox(true);
  }

   //загрузка Фоб
   useEffect(() => {
    const fetchPonBoxData = async () => {
      try {
        const [data, divider, polishing] = await Promise.all([
          loadingPonBoxDataComponent(),
          loadingDividerDataComponent(),
          loadingPolishingDataComponent(),
        ]);
        setDividerData(divider);
        setPonBoxData(data);
        setPolishingData(polishing);
      } catch (error) {
        console.error("Error in fetchPonBoxData:", error);
      }
    };
  
    fetchPonBoxData();
  }, []);

   const deletePonBox = () => {
          DeletePonBoxConstruction(content.id, showSnackbar, cantonRefresh, handleCloseDialogs );
   }; 

  const handleCloseDialogs = () => {
    onClose2();
    onClose();
  };

 
  const handleDescriptionChange = (event) => {
    const newText = event.target.value;
    setTextComment(newText);

    if (newText !== content.comment) {
        setStatusChange(true);
    } else {
        setStatusChange(false);
    }
 };

  const handleChangePolishingSelect = (event) => {
    const selectedPolishing = event.target.value;
    if (selectedPolishing === "") {
      setPolishingId(content.polishingId);
    } else {
      const selectedPolishing2 = polishingData.find(polishing => 
        `${polishing.id}` === selectedPolishing
      );
      if (selectedPolishing2) {
        setPolishingId(selectedPolishing2.id);
      }
    }
  };

   const handleAdapterChange = (event) => {
    const adapter = event.target.value;
    setAdapterCount(adapter);

    if (adapter !== content.adapterCount) {
      setStatusChangeAdapter(true);
    } else {
      setStatusChangeAdapter(false);
    }
  };

   const handlePigtailChange = (event) => {
    const pigtail = event.target.value;
    setPigtailCount(pigtail);

    if (pigtail !== content.pigtailCount) {
      setStatusChangePigtail(true);
    } else {
      setStatusChangePigtail(false);
    }
  };
 
  const updatePonBox = () => {
    if (statusChange) {
      UpdatePonBoxDescriptionConstruction(content.id, textComment, showSnackbar,content.authorId, cantonRefresh);
    } else {
      showSnackbar('Сохранение не требуется, текст без изменений!', 'snackbarOk');
    }
  };

  const handleChangePonBoxSelect = (event) => {
    const selectedPonBox = event.target.value;
    if (selectedPonBox === "") {
      setPonBoxId("");
    } else {
      const selectedPonBox2 = ponBoxData.find(ponBox => 
        `${ponBox.id}` === selectedPonBox
      );
      if (selectedPonBox2) {
        setPonBoxId(selectedPonBox2.id);
      }
    }
  };
 

  const updatePonBoxName = () => {
  
    if (ponBoxId === "") {
      showSnackbar('Сохранение не требуется, пон-бокс без изменений!', 'snackbarOk');
    } else {
      UpdatePonBoxNameConstruction(content.id, ponBoxId, showSnackbar,content.authorId, cantonRefresh );
    } 
  };

      const options = dividerData.map(divider => ({
        value: divider.id,  
        label: divider.model,
        group: divider.polishingId === 1 ? "UPC" : "APC", 
      }));
    
      // Группировка опций
      const groupedOptions = [
        {
          label: "UPC",
          options: options.filter(option => option.group === "UPC"),
        },
        {
          label: "APC",
          options: options.filter(option => option.group === "APC"),
        },
      ];

      const handleChangeDividerSelect = (selectedOption) => {
        if (!selectedOption) {
          setDividerId(""); 
          return;
        }  
      
        const selectedDivider = selectedOption.value; 
        
        const selectedDividerData = dividerData.find(divider => `${divider.id}` === `${selectedDivider}`);
        
        if (selectedDividerData) {
          setDividerId(selectedDividerData.id);
        }
      };

      const handleChangeDivider2Select = (selectedOption) => {
        if (!selectedOption) {
          setDivider2Id(""); 
          return;
        }  
      
        const selectedDivider = selectedOption.value; // `react-select` передает объект { value, label }
        
        const selectedDividerData = dividerData.find(divider => `${divider.id}` === `${selectedDivider}`);
        
        if (selectedDividerData) {
          setDivider2Id(selectedDividerData.id);
        }
      };

       const updateModel = () => {
        
          if (dividerId === "") {
            showSnackbar('Нет нужды в записи, делитель без изменений!', 'snackbarOk');
          } else {
            UpdateDividerModelPonBoxConstruction(content.id, dividerId, content.authorId, showSnackbar, cantonRefresh );
          } 
        };

        const updateModel2 = () => {
        
          if (divider2Id === "") {
            showSnackbar('Сохранение не требуется, делитель2 без изменений!', 'snackbarOk');
          } else {
            UpdateDivider2ModelPonBoxConstruction(content.id, divider2Id, content.authorId, showSnackbar, cantonRefresh );
          } 
        };


        const handleCheckboxChange = () => {
          setShowSecondDivider(prev => !prev);
        };

        const handleNumberBoxChange = (event) => {
          const newText = event.target.value;
          setTextNumberBox(newText.trim() === "" ? null : newText);
        
          if (newText !== content.numberBox) {
            setStatusChangeNumberBox(true);
          } else {
            setStatusChangeNumberBox(false);
          }
        };

        const updateNumberBox = () => {
          if (statusChangeNumberBox) {
            UpdateNumberPonBoxConstructor(content.id, textNumberBox, showSnackbar,content.authorId, cantonRefresh );
          } else {
            showSnackbar('Сохранение не требуется, номер без изменений!', 'snackbarOk');
          }
        };

         const updatePigtailAdapter = () => {
            if (statusChangeAdapter || statusChangePigtail) {
                UpdatePigtailAdapterPonBoxConstruction(content.id, pigtailCount, adapterCount, polishingId,content.authorId, showSnackbar, cantonRefresh );
            } else {
                showSnackbar('Нет нужды в записи, длина без изменений!', 'snackbarOk');
            }
         };

    return (
  
    <Dialog open={open} className="dialogStyle">
    
      <DialogContent>
           <img src='./ponbox.png' width='30' height='30' style={{ marginRight: "5px" }} />
          
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset',textShadow: '2px 2px 4px #3d3d3d'}}>Редактирование Пон-бокс</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe',textShadow: '2px 2px 4px #3d3d3d' }}>{content.id}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Территория: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.canton} {content.region} {content.area}</span> </label>
     
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Пон-бокс: </label>

      <select className="selectStyleDrawer" 

        onChange={(event) => {
          handleChangePonBoxSelect(event);
        }} >
        <option value="">{content.fobName}</option>
        {ponBoxData.map(ponBox => (
          <option key={ponBox.id} value={ponBox.id}>{ponBox.name}</option>
        ))}
      </select>
      <button onClick={updatePonBoxName} class='buttonIsSaveDialog2'>Сохранить</button>
    
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
     
         <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <label style={{ color: "#292929", fontWeight: "bold" }}>Делитель:</label>
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <input type="checkbox" checked={showSecondDivider} onChange={handleCheckboxChange} />
              <span style={{ color: "#292929", fontWeight: "bold" }}>+1</span>
            </div>
          </div>

             <Select
               className="selectSearchDrawer"
               options={groupedOptions}
               inputValue={inputValue}
               styles={customStyles}
               onInputChange={value => setInputValue(value)} 
               onChange={handleChangeDividerSelect}
               placeholder={content.dividerModel || "Выберите делитель"}
               isClearable
             />
        <button onClick={updateModel} class='buttonIsSaveDialog2' style={{fontSize: '14px', paddingTop: '3px', paddingBottom: '3px'}}>Сохранить</button> 

       {showSecondDivider && (
            <>
              <Select
                className="selectSearchDrawer"
                options={groupedOptions}
                inputValue={inputValue2}
                styles={customStyles}
                onInputChange={value => setInputValue2(value)}
                onChange={handleChangeDivider2Select}
                placeholder={content.dividerModel2 || "Выберите делитель2"}
                isClearable
              />
              <button onClick={updateModel2} className="buttonIsSaveDialog2" style={{ fontSize: '14px', paddingTop: '3px', paddingBottom: '3px' }}>
                Сохранить
              </button>
            </>
            )}
        <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
         <div className="divСommunicationsDrawer" style={{ border: '1px solid #d6b220'}}>
          <label className='textTitleDrawer' style={{ fontSize: '16px', marginRight: '10px'}}>Полировка: </label>

          <select className="selectStyleDrawer" style={{marginBottom: '10px'}} 

            onChange={(event) => {
              handleChangePolishingSelect(event);
            }} >
            <option value="">{content.polishingType}</option>
            {polishingData.map(polishing => (
              <option key={polishing.id} value={polishing.id}>{polishing.type}</option>
            ))}
          </select>
            <br/>
           <label className='textTitleDrawer' style={{ fontSize: '16px'}}>Pigtail: </label>
       
            <input
              type='number'
              className='textInput2EditingModal'
              value={pigtailCount} 
              min={0}
              onChange={handlePigtailChange} 
            /> <label className='textTitleDrawer' style={{marginLeft: '5px', fontSize: '16px'}}>кол. </label>
              <br/>
           <label className='textTitleDrawer' style={{ fontSize: '16px'}}>Adapter: </label>
       
            <input
              type='number'
              className='textInput2EditingModal'
              min={0}
              value={adapterCount} 
              onChange={handleAdapterChange} 
            /> <label className='textTitleDrawer' style={{marginLeft: '5px', fontSize: '16px'}}>кол. </label>
            <br/>
             <button onClick={updatePigtailAdapter}  class='buttonIsSaveDialog2'>Сохранить</button>
      </div>
        <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <label style={{ color: '#292929', fontWeight: 'bold'}}>Внес: <span style={{ color: '#bebebe',fontWeight: 'normal',textShadow: '2px 2px 4px #3d3d3d' }}>{content.authorId}</span></label>
      <br/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Дата добавления: <span style={{ color: '#bebebe',fontWeight: 'normal' ,textShadow: '2px 2px 4px #3d3d3d'}}>{new Date(content.createDate).toISOString().slice(0, 19).replace("T", " ")}</span></label>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 

      <label style={{ color: '#292929', fontWeight: 'bold' }}>Номер бокса: </label>

      <input
        className='textInputEditingModal'
        style={{width: '100px'}}
         value={textNumberBox} 
         onChange={handleNumberBoxChange} 
      />
      <button onClick={updateNumberBox} class='buttonIsSaveDialog2'>Сохранить</button>
      <hr className="horizontalLineDialog2" style={{marginTop: "1px"}}/> 


      <label style={{ color: '#292929', fontWeight: 'bold'}}>Комментарий:</label>
       
        <textarea
          className='textAreaEditingModal'
          value={textComment} 
          onChange={handleDescriptionChange} 
        />

      <br/>
      <button onClick={updatePonBox} class='buttonIsSaveDialog2' style={{marginLeft:"0px"}}>Сохранить</button>

      <hr className='horizontalLineDialog'/>

      <button  class='buttonIsEditDialog' onClick={handleСhangeCoor}> Редактировать на карте</button>

      <hr className='horizontalLineDialog'/>

      <button 
          className="buttonIsDeleteModal" 
          onClick={deletePonBox} 
          style={{ fontSize: "14px", width: "60px", padding: "2px",textShadow: '2px 2px 4px #3d3d3d' }}
        >
          Удалить
        </button>
    
      <hr className='horizontalLineDialog'/>
     

      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>

       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />
    </Dialog>
  );
}

export default PonBoxDescriptEditingModal;